import { http } from '@/http-common'

type Evaluation = {
    value: number|undefined,
    symbol: string|undefined
}

export default async function convertUnit(value: number|undefined, originalUnit: string|undefined, newUnit: string|undefined): Promise<Evaluation> {
    if (value === undefined || value === null
        || originalUnit === undefined || originalUnit === null
        || newUnit === undefined || newUnit === null
    ) {
        return { value: value, symbol: originalUnit }
    }

    return await http.get(`unit/convert?value=${value}&originalUnit=${originalUnit}&newUnit=${newUnit}`)
        .then(result => {
            return result.data
        })
        .catch(() => {
            return { value: undefined, symbol: undefined }
        })
}
